import React, { use, useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Divider,
    ToggleButton,
    ToggleButtonGroup,
    Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton,
    TextField, FormControl,
    Alert,
    Stack,
    DialogContentText
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import { useForm } from "react-hook-form";
import MyCardDetails from "./mycardDeatils";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import moment from "moment";
const PlansPage = () => {
    const [billingCycle, setBillingCycle] = useState("Monthly");

    const handleBillingChange = (event , newBillingCycle) => {
        if (newBillingCycle) {
            setBillingCycle(newBillingCycle);
        }
        let monthlydata = []
        Allplans.map((data, i) => {
            if (data.billing_cycle == newBillingCycle) {
                monthlydata.push(data)
            }
        })
        setPlans([...monthlydata]);

    };
    const { register, handleSubmit, formState: { errors }, trigger, setValue } = useForm();
    const [plans, setPlans] = useState([])
    const [Allplans, setAllPlans] = useState([])
    const navigate = useNavigate()
    const [openDialog, setOpenDialog] = useState(false);
    const [confirmPop, setconfirmPop] = useState(false);
    const [confirmPop2, setconfirmPop2] = useState(false);
    const [current_subscription_id, setcurrent_subscription_id] = useState()
    const [OpenMail, setOpenMail] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedprotated, setselectedprotated] = useState([]);
    const [activePlan, setActivePlan] = useState(null);
    const [subscription_id, setsubscription_id] = useState({});
    const [openModal, setOpenModal] = useState(false)
    const [ActivePlanData, setActivePlanData] = useState(null);
    const [error, seterror] = useState('')
    const [loader, setloader] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false);
    const [referenceId, setReferenceId] = useState(null);
    const [userinfo, setuserinfo] = useState(JSON.parse(sessionStorage.getItem('user-info')))
    const [orderid, setOrderid] = useState()
    const [paidsubscription, setpaidsubscription] = useState(false)
    const GetPlans = async () => {
        setloader(true)
        try {
            axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
            const response = await axios.get("/apiV1/subscription-plans/");
            if (response.status === 200) {
                setloader(false)
                const fetchedPlans = response.data;
                setAllPlans([...fetchedPlans])
                let monthlydata = []
                fetchedPlans.map((data, i) => {
                    if (data.billing_cycle == "Monthly") {
                        monthlydata.push(data)
                    }
                })
                setPlans([...monthlydata]);

            }
        } catch (err) {
            setloader(true)
            console.log("Error fetching plans:", err);
        }
    };
    const CancelSubscription = async () => {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        let req = {
            current_subscription_id: current_subscription_id
        }
        axios.post(`/apiV1/cancel-subscription/`, req).then((res) => {
            if (res.data) {
                GetPlans();
                setconfirmPop2(false)
            }
        }).catch((e) => { console.log(e) });
    }
    useEffect(() => {
        GetPlans()
    }, [])
    useEffect(() => {
        if (plans.length > 0) {
            const currentPlan = plans.find(plan => plan.current_plan === true);
            if (currentPlan) setActivePlan(currentPlan.id);
        }
    }, [plans]);
    useEffect(() => {
        setValue("email", "enquiry@pranathiss.com");
        setValue("planName", selectedPlan?.name || "");
    }, [setValue, selectedPlan]);
    const [selectedPlans, setSelectedPlans] = useState(null);
    const [selectedPlanFromUser, setselectedPlanFromUser] = useState({})
    const [onclickselect, setonclickselect] = useState({})
    const handleCardClick = (index) => {
        setSelectedPlans(index);
    };
    const onselectPlanvalue = (id) => {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.get(`/apiV1/get-plan-bill-details/?plan_id=${id}&user_id=${userinfo.id}`).then((res) => {
            if (res.data) {
                setonclickselect(res.data)
                let sublist = []
                for (const [key, value] of Object.entries(res.data)) {
                    let objects = value;
                    objects.name = key
                    sublist.push(objects)
                }
                setselectedprotated([...sublist])
            }

        }).catch((e) => { console.log(e) });
    }
    const CreateNewBillingDetails = () => {
        if (selectedPlans == null) {
            alert('Please Select Prorated Amount or Full Amount')
            return false
        }
        if (selectedPlans == 1) {
            onclickselect['pro_rata_details'].amount = onclickselect['regular_plan_details'].amount
            onclickselect['pro_rata_details'].no_basic_chatbots = onclickselect['regular_plan_details'].no_basic_chatbots
            onclickselect['pro_rata_details'].no_messages = onclickselect['regular_plan_details'].no_messages
            onclickselect['pro_rata_details'].no_of_advances_chatbots = onclickselect['regular_plan_details'].no_of_advances_chatbots
            onclickselect['pro_rata_details'].no_of_generate_all = onclickselect['regular_plan_details'].no_of_generate_all
            onclickselect['pro_rata_details'].no_of_intent_trains = onclickselect['regular_plan_details'].no_of_intent_trains
            onclickselect['pro_rata_details'].no_of_intents = onclickselect['regular_plan_details'].no_of_intents
            onclickselect['pro_rata_details'].no_of_kb_trains = onclickselect['regular_plan_details'].no_of_kb_trains
            
        }


        let req = {
            customer_id: userinfo.id,
            order_meta: {
                
                bill_info: onclickselect
            }
        }
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`/apiV1/create-subscription-order/`, req).then((res) => {
            if (res.data) {
                setOrderid(res.data.data.order_id)
                
                setOpenModal(true)
                
            }

        }).catch((e) => { console.log(e) });
    }
    return (



        <>
            {loader ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "82vh" }}>
                    <div className='text-center mt-2'>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                </Box>
            ) : plans.length === 0 ? (
                <Box sx={{ textAlign: "center", padding: 3 }}>
                    No Data Found

                </Box>
            ) : (
                <div style={{ paddingTop: 20 }}>

                    <div className="row mb-3 mt-2">
                        <div className='col-md-6 col-sm-6 mt-2'>
                            <ToggleButtonGroup value={billingCycle} exclusive onChange={handleBillingChange} className="toggleHolder"
                                
                            >
                                <ToggleButton value="Monthly" className="togglebutton"  > Monthly </ToggleButton>
                                <ToggleButton value="Annually"  className="togglebutton" > Annually </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div className='col-md-6 text-end  col-sm-6'>
                            <Link to="/mycarddetails" style={{ width: "initial" }} className="position-relative d-inline-flex align-items-center greaditentbutton justify-content-center p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s", }} >
                                    <CreditCardIcon />  My Card Details
                                </span>
                            </Link>
                            <Link to="/transactionhistory" style={{ width: "initial" }} className="position-relative d-inline-flex align-items-center greaditentbutton justify-content-center p-1  me-2 overflow-hidden text-sm fw-medium text-dark rounded-lg border-0" >
                                <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s", }} >
                                    <ReceiptLongIcon />  Transaction History
                                </span>
                            </Link>

                        </div>
                    </div>
                    {!selectedPlan?.id ?
                        <>
                            <Grid container >
                                <Grid item xs={12} lg={9}   >
                                    <Card sx={{ p: 3 }}  >
                                        <Grid container spacing={2} >
                                            {plans.map((plan) => (
                                                <Grid item xs={12} sm={6} md={4} key={plan.id}>
                                                    <Card
                                                        onClick={() => { setActivePlan(plan.id); onselectPlanvalue(plan.id); setsubscription_id(plan) }}
                                                        className="planingcards"
                                                        sx={{ boxShadow: activePlan === plan.id ? "0px 8px 20px rgba(74, 58, 255, 0.2)" : "none", border: activePlan === plan.id  ? "2px solid #66a321"   : "1px solid #e0e0e0", }}
                                                    >
                                                        <CardContent>
                                                            {plan.is_current_plan && (
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        width: "100%",
                                                                        position: "relative",
                                                                        bottom: "31px",
                                                                        left: "33px",
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            backgroundColor: "#66a321",
                                                                            color: "#fff",
                                                                            fontSize: "12px",
                                                                            fontWeight: "bold",
                                                                            padding: "6px 8px",
                                                                        }}
                                                                    >
                                                                        Current Plan
                                                                    </Box>
                                                                </Box>
                                                            )}

                                                            <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                                                                {plan.name}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {plan.description}
                                                            </Typography>
                                                            <Typography
                                                                variant="h4"
                                                                sx={{ fontWeight: "bold", marginTop: 2, marginBottom: 2 }}
                                                            >
                                                                ${plan.price}
                                                            </Typography>
                                                            {plan.duration_months && <Typography sx={{ mb: 2 }}>Duration Months : {plan.duration_months}</Typography>}
                                                            {plan.trial && (
                                                                <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                                    {plan.trial}
                                                                </Typography>
                                                            )}
                                                            <Divider sx={{ marginBottom: 2 }} />
                                                            <Box>
                                                                {plan.perks?.length > 0 ? (
                                                                    plan.perks.map((feature, i) => (
                                                                        <Typography key={i} variant="body1" sx={{ marginBottom: 1, textAlign: "left" }}>
                                                                            ✓ {typeof feature === "string" ? feature : feature.name || "Feature"}
                                                                        </Typography>
                                                                    ))
                                                                ) : (
                                                                    <Typography variant="body2" color="text.secondary">
                                                                        No features available
                                                                    </Typography>
                                                                )}
                                                            </Box>

                                                            <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                                                            {/* <button type="button" style={{ height: "40px",   }}  onClick={() => {
                                                    if (plan.is_current_plan) {
                                                        //setOpenDialog(true);
                                                        setSelectedPlan(plan);
                                                    } else { setSelectedPlan(plan); 
                                                        //setconfirmPop(true); 
                                                    }
                                                }} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > {plan.is_current_plan ? "Renewal Your Plan" : "Upgrade Your plan"} </span>
                                                </button>
                                                 */}



                                                            {plan.is_current_plan ?
                                                                <button type="button" onClick={() => { setconfirmPop2(true); setcurrent_subscription_id(plan.plan_id) }} style={{ height: "40px", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }}
                                                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }}  >
                                                                        Cancel Your Subscription
                                                                    </span>
                                                                </button>
                                                                : ""}
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>

                                    </Card>

                                </Grid>
                                <Grid item xs={12} lg={3} px={3} >
                                    {selectedprotated.map((pland, i) => {
                                        return (
                                            <Card style={{ marginBottom: "15px", cursor: 'pointer', padding: "10px" }} mt={2} onClick={() => handleCardClick(i)} className={selectedPlans === i ? 'selected' : ''}  >
                                                <Typography variant="h6" style={{ color: "#182286" }} ><input type='radio' checked={selectedPlans === i ? true : false} /> {pland.name == 'pro_rata_details' ? "Prorated Amount" : "Full Amount"}</Typography>
                                                <Typography sx={{ pt: 2, pb: 2 }}>{pland.name == 'pro_rata_data' ? "Amount & services are calculated for the remaining days left in the current month " : "Full amount will be debited as per the current plan"}</Typography>
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <Box mr="auto"  >
                                                        <Typography sx={{ maxWidth: '150px' }}>
                                                            Current Plan
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.plan_name} </Box>
                                                </Stack>
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <Box mr="auto"  >
                                                        <Typography sx={{ maxWidth: '150px' }}>
                                                            No Basic Chatbots
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.no_basic_chatbots} </Box>
                                                </Stack>
                                              
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <Box mr="auto"  >
                                                        <Typography sx={{ maxWidth: '150px' }}>
                                                            Advances Chatbots
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.no_of_advances_chatbots} </Box>
                                                </Stack>
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                <Box mr="auto"  >
                                                    <Typography sx={{ maxWidth: '150px' }}>
                                                    No Messages
                                                    </Typography>
                                                </Box>
                                                <Box style={{ color: "#182286", fontWeight: "bold" }}> { pland.no_messages} </Box>
                                            </Stack>
                                                {/* <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                <Box mr="auto"  >
                                                    <Typography sx={{ maxWidth: '150px' }}>
                                                    No of Generate All
                                                    </Typography>
                                                </Box>
                                                <Box style={{ color: "#182286", fontWeight: "bold" }}> { pland.no_of_generate_all} </Box>
                                            </Stack> */}

                                                {/* <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                <Box mr="auto"  >
                                                    <Typography sx={{ maxWidth: '150px' }}>
                                                    No of Intent Trains
                                                    </Typography>
                                                </Box>
                                                <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.no_of_intent_trains} </Box>
                                            </Stack> */}
                                                {/* <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <Box mr="auto"  >
                                                        <Typography sx={{ maxWidth: '150px' }}>
                                                            No of Intents
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.no_of_intents} </Box>
                                                </Stack>
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <Box mr="auto"  >
                                                        <Typography sx={{ maxWidth: '150px' }}>
                                                            No of kb trains
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ color: "#182286", fontWeight: "bold" }}> {pland.no_of_kb_trains} </Box>
                                                </Stack> */}
                                                <Stack direction="row" gap="10px" alignItems="center" sx={{ mb: 2 }}>
                                                    <TextField fullWidth variant="outlined" id="email" className='textfieldsininput' InputProps={{ readOnly: true, }} value={"$" + pland.amount} />

                                                </Stack>

                                            </Card>
                                        )
                                    })}


                                </Grid>
                            </Grid>
                            {selectedprotated.length !== 0 ?
                            <Grid item xs={12} lg={12} >
                                <div className="text-end mx-3">
                                <button type="button" onClick={() => setselectedprotated([])} style={{ height: "40px", width: "initial", background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))" }}
                                    className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }}  >
                                        Cancel
                                    </span>
                                </button>
                                <button type="submit" style={{ height: "40px", width: "initial" }} onClick={() => CreateNewBillingDetails()} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                                    <span className="position-relative px-4 py-2  rounded-md"  style={{ transition: "0.3s" }} > Save </span>
                                </button>
                                
                                </div>

                            </Grid>: ""}
                        </>

                        :

                        <MyCardDetails amount={selectedPlan.price} subscription_id={selectedPlan.plan_id} type={selectedPlan.is_current_plan ? "RENEWAL" : "NEW"} id={selectedPlan.id} callbackFunction={() => { setSelectedPlan({}); GetPlans(); }} orderid={orderid} />}
                </div>
            )}

            <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)}>
                <DialogTitle>Success</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" gutterBottom>
                        Thank you for reaching out! Our support team will get in touch with you soon.

                    </Typography>
                    {/* <Typography variant="body2">
                        <strong>Reference ID:</strong> {referenceId}
                    </Typography> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSuccess(false)} variant="contained" color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={confirmPop2} onClose={() => { setconfirmPop2(false); setSelectedPlan("") }}>
                <DialogTitle>Alert</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" gutterBottom>
                        Are you sure to cancel your subscription
                    </Typography>

                </DialogContent>
                <DialogActions>


                    <Button onClick={() => { setconfirmPop2(false); setSelectedPlan("") }} variant="contained" color="error">
                        Cancel
                    </Button>
                    <Button onClick={() => CancelSubscription()} variant="contained" color="primary">
                        Cancel Subscription
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Current Plan Details
                    <IconButton onClick={() => setOpenDialog(false)}>
                        <CloseIcon size={24} />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {selectedPlan && <>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                            {selectedPlan.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            {selectedPlan.description}
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 1 }}>
                            ${selectedPlan.price} / {selectedPlan.duration_months} month(s)
                        </Typography>


                        <Box>
                            <Typography variant="body1" sx={{ marginBottom: 1, textAlign: "left" }}>
                                ✓ Start Date : {new Date(selectedPlan.start_date).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }).replace(/\//g, "-")}
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 1, textAlign: "left" }}>
                                ✓ End Date : {new Date(selectedPlan.end_date).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                }).replace(/\//g, "-")}
                            </Typography>
                            {selectedPlan.perks?.length > 0 ? (
                                selectedPlan.perks.map((feature, i) => (
                                    <Typography key={i} variant="body1" sx={{ marginBottom: 1, textAlign: "left" }}>
                                        ✓ {typeof feature === "string" ? feature : feature.name || "Feature"}
                                    </Typography>
                                ))
                            ) : (
                                <div></div>
                            )}
                        </Box>




                    </>}
                    <Divider />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} disableEscapeKeyDown onBackdropClick >
                <DialogTitle>Order</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your order created successfully
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained"  onClick={()=> {setSelectedPlan(subscription_id); setOpenModal(false)}} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PlansPage;
